import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import LoadingSuccessErrorAlert from "./LoadingSuccessErrorAlert";
import { AppContext } from "../../../../Context/AppContext";
import AppSettings from "../../../../Settings/AppSettings";
import Card from "Components/DesignSystem/Card/Card";
import Button from "Components/DesignSystem/Button/Button";
import Typography from "Components/DesignSystem/Typography/Typography";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import ReactHtmlParser from "react-html-parser";

const LongDescription = ({ productID, productDescriptionAvailable, longDescription, setLongDescription, setInitialDescriptionAndImages }) => {
  const { setLongDescriptionGlobal } = useContext(AppContext);
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [Loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [editPage, setEditPage] = useState(false);
  useEffect(() => setLoading({
      status: "",
      message: "",
  }), [longDescription])
  useEffect(() => {
    if (productID !== "0" && productDescriptionAvailable) {
      load_Long_Description(productID);
    }
  }, [productID]);

  async function load_Long_Description(productID) {
    setLoading({
      status: "Loading",
      message: "Loading Long Description",
    });
    let ret = await ServiceWrapper.doGet(
      `${api_base_url}product/${productID}/description/get`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!ret.errorfound) {
      setLongDescription(ret.data.data);
      setInitialDescriptionAndImages((prev) =>{
        return  {...prev, description: ret.data.data}
      })
      setLoading({
        status: "Success",
        message: undefined,
      });
    } else {
      setLoading({
        status: "Error",
        message: "Error while Loading Long Description",
      });
    }
  }

  async function handleChange(value) {
    setLongDescription(value);
  }

  async function on_save() {
    if (productID === "0") {
      setLongDescriptionGlobal(longDescription);
      setEditPage(false);
      setLoading({
        status: "Success",
        message: "",
      });
      return;
    }
    setLoading({
      status: "Saving",
      message: "Saving changes",
    });

    let res = await ServiceWrapper.doPost(
      `${api_base_url}product/${productID}/description/save`,
      {
        description: longDescription,
        isRichText: true,
      },
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res.data.done) {
        setInitialDescriptionAndImages((prev) =>{
          return  {...prev, description: longDescription}
        })
        setLoading({
          status: "Success",
          message: res.data.message,
        });
        setEditPage(false);
      } else {
        setLoading({
          status: "Error",
          message: res.data.message,
        });
      }
    } else {
      setLoading({
        status: "Error",
        message: "Error while saving, Please try after some time.",
      });
    }
  }

  return (
    <Card className="tw-w-[890px] tw-ms-2.5" data-testid="product-long-description-panel">
      <div className="tw-flex tw-items-center tw-justify-between">
        <Typography className="tw-text-ink" variant="title-header" as="h3">Long Description</Typography>
        {!editPage ? (
          <Button
            variant="primary"
            data-testid="product-long-description-edit-btn"
            onClick={() => {
              setEditPage(true);
            }}
          >
            Edit
          </Button>
        ) : (
          <div className="tw-flex tw-items-center tw-gap-3">
            <Button
              variant="secondary"
              data-testid="product-long-description-cancel-btn"
              onClick={() => setEditPage(false)}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              data-testid="components-longdescription-button-1"
              onClick={on_save}
            >
              Save
            </Button>
          </div>
        )}
      </div>
      <div className="tw-mt-3" style={{ minHeight: "200px" }}>
        {Loading.status !== "Loading" && (
          <>
            {editPage ? (
              <ReactQuill
                theme="snow"
                value={longDescription}
                onChange={handleChange}
              />
            ) : (
              <div>
                {longDescription ? (
                  ReactHtmlParser(longDescription)
                ) : (
                  <Typography variant="body-primary" as="span" className="tw-text-ink-tertiary">Long description is empty</Typography>
                )}
              </div>
            )}
          </>
        )}
        <LoadingSuccessErrorAlert loading={Loading} />
      </div>
    </Card>
  );
};
export default LongDescription;
